<template>
  <router-view />
</template>

<script>
export default {
  name: 'App',
  components: {
  }
}
</script>

<style lang="scss">
@import "~@/assets/scss/_reset.scss";
@import "~@/assets/scss/_common.scss";
@import "~@/assets/scss/_font.scss";

body {
	// @include scrollbar;
}
</style>
